import React from 'react'
import ArrowLink from './ArrowLink'
import StatusIndicator from './StatusIndicator'
import BalanceCard from './BalanceCard'
import AccountInfo from './AccountInfo'
import TextContent from './TextContent'
import CustomButton from './CustomButton' 

function Main() {
  return (
    <div>        
        <ArrowLink/>
        <StatusIndicator/>
        <BalanceCard/>
        <AccountInfo/>
        <TextContent/>
        <CustomButton/>        
    </div>
  )
}

export default Main;
